<template>
  <div style = "height:100%;width:100%;overflow:hidden;">
      <iframe v-iframeloaded :ref = "`iframes${item._id_}`" v-show = "item.name === $route.name&&(currentTabId == item.tabId)"  v-for = '(item,index) in iframeViews' :key = "item._id_" class = 'ifr' :src = "item.meta.linkUrl+(item.meta.linkUrl.indexOf('?')==-1?'?'+item.queryStr:item.queryStr)" ></iframe>
      <iframe style = "border:0;height:0;display:none;" v-for = '(item,index) in staticIframes' :key = "index" :src = "item.linkUrl"></iframe>
  </div>
</template>

<script>
export default {
  data(){
    return {
      iframeWindow: []
    }
  },
  created(){
    this._event = this.createEvent()
    this.onmessage()
    //本地调用iframe消息
    this.$eventBus.on('HandleIframeMsg',(e)=>{
      this.handleMsg(e)
    })
    //推送iframe消息
    this.$eventBus.on('IframeMsg',(e)=>{
      this.postMessage(e)
    })
    this.$eventBus.on('TAB_ROUTE_ACTIVED',(e) =>{
      if(this.$refs[`iframes${e._id_}`]&&this.$refs[`iframes${e._id_}`][0]&&this.$refs[`iframes${e._id_}`][0].contentWindow){
        this.$refs[`iframes${e._id_}`][0].contentWindow.postMessage(
        {
          type: 'CMSC_MSG',
          msg: {
            type: '__broadcast',
            msg: {
              type: 'pageActived',
              msg: e._id_
            }
          }
        },'*')
      }
    })
  },
  watch: {
    $route(val){
      if(val.meta&&val.meta.isFrame){
        this.$http.get('/sctm/auth/getLoginState')
      }
    }
  },
  mounted(){
    this.loadOutScript()
  },
  computed: {
    staticIframes(){
      return this.$store.state.main.menus.staticIframes
    },
    iframeViews(){
      return this.$store.state.main.menus.tabs.filter(item => {
        return item.meta&&item.meta.linkUrl
      })
    },
    cinVccbar(){
      if(this.$store.state.cincc){
        return this.$store.state.cincc.cinVccBar
      }else{
        return null
      }
    },
    headTab(){
      return this.$store.state.main.menus.headTabVm
    },
    currentTabId(){
      let tabId = ''
      if(this.$route.query&&this.$route.query.tab_id){
        return this.$route.query.tab_id
      }else if(this.$route.meta&&this.$route.meta.tabId){
        return this.$route.meta.tabId
      }
    }
  },
  methods: {
    onmessage(){
      window.onmessage = (e) => {
        let {data} = e
        if(data.type&&data.type === 'CMSC_MSG'){
          let msg = data.msg
          if(msg.type == 'syncInfo'){
            console.log(msg)
          }
          this.handleMsg(msg)
        }
      }
    },
    handleMsg(msg){
      this._event[msg.type]&&this._event[msg.type](msg.msg)
    },
    createEvent(){
      var _this = this
      return {
        message(msg){
          let {type} = msg
          if(type === 'error'){
            _this.$Message.error(msg.msg)
          }else if(type === 'success'){
            _this.$Message.success(msg.msg)
          }else if(type === 'warning'){
            _this.$Message.warning(msg.msg)
          }
        },
        confirm(msg){
          _this.$Modal.confirm({
            title: msg.title,
            content: msg.content,
            onOk:()=>{
              console.log('testiframe---',msg)
              _this.postMessage({
                  type:'confirmOk',
                  id: msg.id
              })
            },
            onCancel:()=>{
              _this.postMessage({
                type:'confirmCancel',
                id: msg.id
              })
            }
          })
        },
        //双呼
        callEachother(data){
          let {caller,called} = data
          let userInfo = JSON.parse(localStorage.user).info
          let tenantId = userInfo.tenantId
          _this.$http.post('/sccs/callCenterInfo/excuteTwc',{
            caller,
            called,
            tenantId
          }).then(({data}) => {
            if(data.returnCode == '0'){
              _this.$Message.success('呼叫成功')
            }else{
              _this.$Message.error(data.returnMessage)
            }
          })
        },
        //拨号
        makeCall(data){
          console.log('拨号',data)
          if(_this.cinVccbar){
            _this.cinVccbar.makeCall(data, 3, '', '', '')
          }
        },
        //挂断
        disConnect(){
          if(_this.cinVccbar){
            _this.cinVccbar.disconnect(0)
          }
        },
        //关闭当前页签
        closeCurrentTab(){
          if(_this.headTab){
            _this.headTab.deleNowTab1()
          }
        },
        //通过id关闭页签
        closeTabById(id){
          if(_this.headTab){
            _this.headTab.deleTabById(id)
          }
        },
        //跳转路由
        navigateTo(params){
          let query = params.query || {}
          //同一个路由不同页签需要传入tabId
          if(params.id){
            query.tab_id = params.id
          }
          if(params.title){
            query.tab_title = params.title
          }
          console.log('totab--',params)
          _this.$router.push({
            path: params.path,
            query,
            params: params.params || {},
          })
        },
        //通过id切换tab
        switchTabById(id){
          console.log(id)
          if(_this.headTab){
            _this.headTab.switchTabById(id)
          }
        },
        //创建一个路由
        createRoute(params){
          _this.$addRoutes([{
            path: `/${params.name}_${params.id}`,
            name: params.name,
            meta: {
              title: params.title,
              tabId: params.id,
              linkUrl: params.linkUrl || ''
            }
          }])
        },
        //通过id刷新一个iframe
        reloadIframeById(id){
          
        },
        broadcast(params){
          _this.postMessage({
            type:'__broadcast',
            msg: params
          })
        }
      }
    },
    postMessage(msg){
      let iframes = document.getElementsByTagName('iframe')
      for(let i in iframes){
        let data = {
          type: 'CMSC_MSG',
          msg
        }
        iframes[i].contentWindow&&iframes[i].contentWindow.postMessage(data,'*')
      }
    },
    //通过id获取对应的tabroute
    getIframeIndexById(id){
        let tabs = this.iframeViews
        for(let i in tabs){
            if(tabs[i].tabId&&(tabs[i].tabId == id)){
                return i
            }
        }
    },
    //加载外部js脚本
    loadOutScript(){
      console.log('外部脚本---',this.$store.state.main.menus.outScript)
      let scripts = this.$store.state.main.menus.outScript
      if(scripts&&scripts.length){
        for(let i in scripts){
          var _script = document.createElement('script')
          _script.src = scripts[i].linkUrl
          document.body.appendChild(_script)
        }
      }
    }
  },
  directives: {
    iframeloaded: {
      inserted(el,binding,vnode){
        console.log('iframe--load',el)
      }
    }
  }
}
</script>

<style scoped lang = "less">
.ifr{
    width:100%;
    height:100%;
    border:none;
}
</style>